/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/**
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Gegenereerd met Claude Code (AI), 10-09-2026
 *
 * Component voor de replaybalk linksboven het modelcanvas (tot golf 4f een Custom Element): de vijf
 * knoppen (naar begin, terug, verder, naar eind, stop) en de teller. Vervangt het `#replay`-blok in canvas.html. De balk regelt
 * zijn eigen zichtbaarheid via de `actief`-signal van de `ReplayService` en stuurt diezelfde service
 * aan; alle stappenstand leeft daar.
 */
import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {BaseIslandComponent} from '../base-island.component';
import {ReplayService} from '../../app/replay/replay.service';

@Component({
    selector: 'dl-replaybalk',
    standalone: true,
    templateUrl: './dl-replaybalk.component.html',
    styleUrls: ['./dl-replaybalk.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe],
    host: {
        '[class.dl-replaybalk--zichtbaar]': 'replay.actief()'
    }
})
export class DlReplaybalkComponent extends BaseIslandComponent {

    /**
     * De replay-service: de stappenstand (`huidige`, `aantal`, `eerste`, `laatste`) en de zes
     * ingangen. De balk leest hem en stuurt hem aan.
     */
    protected readonly replay = inject(ReplayService);

    constructor() {
        super();
    }
}
